import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/suggestedActions/SuggestedAction.module_built.css";
const classes = {"suggested-action__image":"wenGMeW_suggested-action__image","suggested-action":"wenGMeW_suggested-action"}
export default classes

const _suggested_action__image0 = classes["suggested-action__image"]
export { _suggested_action__image0 as "suggested-action__image" }

const _suggested_action0 = classes["suggested-action"]
export { _suggested_action0 as "suggested-action" }
